<template>
    <ul class="pagination pagination-sm">
        <li v-bind:class="{ 'disabled' : page === 1}">
            <a href="javascript:void(0)" @click="go(page-1)"><i class="fa fa-angle-left"></i></a>
        </li>
        <li v-for="p of pages" v-bind:class="{ 'active' : page === p}">
            <a href="javascript:void(0)" @click="go(p)">{{ p }}</a>
        </li>
        <li v-bind:class="{ 'disabled' : page === pages.length}">
            <a href="javascript:void(0)" @click="go(page+1)"><i class="fa fa-angle-right"></i></a>
        </li>
    </ul>
</template>

<script>
    export default {
        components: {
        },
        props: {
            count: { type: Number, default: 0 },
            total: { type: Number, default: 0 },
            page: { type: Number, default: 1 },
        },
        computed: {
            totalPageCount: function () {
                return Math.max(1, Math.ceil(this.total / this.count));
            },
            pages: function () {
                const maxPagesSeen = this.totalPageCount > 10 ? 10 : this.totalPageCount;
                const maxPagesSeenMultiple = Math.ceil(this.totalPageCount / maxPagesSeen);

                let pageStart_1base = 1;
                if(this.page > maxPagesSeen / 2) {
                    pageStart_1base = this.page - Math.floor(maxPagesSeen / 2);
                }
                if(this.page > this.totalPageCount - (maxPagesSeen / 2)) {
                    pageStart_1base = this.totalPageCount - maxPagesSeen + 1;
                }

                return Array(maxPagesSeen).fill().map((e,i)=>i+pageStart_1base);
            }
        },
        methods: {
            go(page_1base) {
                if(page_1base > 0 && page_1base <= this.totalPageCount) {
                    this.$emit("go", page_1base);
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// page-thingy.vue?c92ccea4